import { Link } from "react-router-dom";

const footerLinks = [
  { label: "首页", to: "/" },
  { label: "剧情详情", to: "/detail" },
  { label: "演员介绍", to: "/cast" },
  { label: "更新日志", to: "/updates" },
  { label: "相关推荐", to: "/related" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">善良的小姨子</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-sm">
              专注影视剧《善良的小姨子》的高清在线观看与内容展示，为剧迷提供剧情介绍、演员信息、更新动态与相关推荐一站式服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer w-fit"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">观剧提示</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                每周三、周五 20:00 更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-hd-line text-accent-400"></i>
                全站高清画质
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                观看问题请前往关于我们反馈
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © 2026 善良的小姨子在线观看 · 本站内容仅供演示学习，所有剧集播放与评论均为前端演示效果
          </p>
          <p className="text-xs text-background-400">影视内容站 · 高清剧集专题</p>
        </div>
      </div>
    </footer>
  );
}